import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import OrderCard from "./order-card";
import "./css/styles.css";
import wd from "./imgs/wd.png";
import gd from "./imgs/graphicDesign.png";
import fin from "./imgs/finResearch.png";
import jas from "./imgs/jandsapps.png";
import cc from "./imgs/cybercofe.png";
import doc from "./imgs/doc.png";
import wed1 from "./imgs/services/web1.webp";
import wed2 from "./imgs/services/webd.jpg";
import wed3 from "./imgs/services/webd2.png";
import wed4 from "./imgs/services/webd3.jpeg";
import wed5 from "./imgs/services/webd4.jpeg";
import wed6 from "./imgs/services/webd5.jpg";
import gr1 from "./imgs/services/gr1.webp";
import gr2 from "./imgs/services/gr2.png";
import gr3 from "./imgs/services/gr3.png";
import gr4 from "./imgs/services/gr4.webp";
import gr5 from "./imgs/services/gr5.webp";
import gr6 from "./imgs/services/gr6.jpeg";
import fx1 from "./imgs/services/fx1.webp";
import fx2 from "./imgs/services/fx2.webp";
import fx3 from "./imgs/services/fx3.jpeg";
import fx4 from "./imgs/services/fx4.png";
import fx5 from "./imgs/services/fx5.webp";
import fx6 from "./imgs/services/fx6.png";
import js1 from "./imgs/services/js1.jpg";
import js2 from "./imgs/services/js2.avif";
import js3 from "./imgs/services/js3.jpg";
import js4 from "./imgs/services/js4.jpg";
import js5 from "./imgs/services/js5.webp";
import js6 from "./imgs/services/js6.png";
import cb1 from "./imgs/services/cb1.jpg";
import cb2 from "./imgs/services/cb2.jpg";
import cb3 from "./imgs/services/cb3.jpg";
import doc1 from "./imgs/services/doc1.jpg";
import doc2 from "./imgs/services/doc2.jpg";
import doc3 from "./imgs/services/doc3.jpg";


// Update additional card data to be an object
const additionalCardsData = {
  1: [
    { id: 1, title: "Grand Shop Website Development", imgSrc: wed1 },
    { id: 2, title: "WD Card 2", imgSrc: wed2 },
    { id: 3, title: "WD Card 3", imgSrc: wed3 },
    { id: 3, title: "WD Card 3", imgSrc: wed4 },
    { id: 3, title: "WD Card 3", imgSrc: wed5 },
    { id: 3, title: "WD Card 3", imgSrc: wed6 },
  ],
  2: [
    { id: 8, title: "JAS Card 1", imgSrc: gr1 },
    { id: 9, title: "JAS Card 2", imgSrc: gr2 },
    { id: 8, title: "JAS Card 1", imgSrc: gr3 },
    { id: 9, title: "JAS Card 2", imgSrc: gr4 },
    { id: 8, title: "JAS Card 1", imgSrc: gr5 },
    { id: 9, title: "JAS Card 2", imgSrc: gr6 },
  ],
  3: [
    { id: 4, title: "GD Card 1", imgSrc: fx1 },
    { id: 5, title: "GD Card 2", imgSrc: fx2 },
    { id: 4, title: "GD Card 1", imgSrc: fx3 },
    { id: 5, title: "GD Card 2", imgSrc: fx4 },
    { id: 4, title: "GD Card 1", imgSrc: fx5 },
    { id: 5, title: "GD Card 2", imgSrc: fx6 },
  ],
  4: [
    { id: 8, title: "JAS Card 1", imgSrc: js1 },
    { id: 9, title: "JAS Card 2", imgSrc: js2 },
    { id: 8, title: "JAS Card 1", imgSrc: js3 },
    { id: 9, title: "JAS Card 2", imgSrc: js4 },
    { id: 8, title: "JAS Card 1", imgSrc: js5 },
    { id: 9, title: "JAS Card 2", imgSrc: js6 },
  ],
  5: [
    { id: 10, title: "CC Card 1", imgSrc: cb1 },
    { id: 10, title: "CC Card 1", imgSrc: cb2 },
    { id: 10, title: "CC Card 1", imgSrc: cb3 },
  ],
  6: [
    { id: 11, title: "Doc Card 1", imgSrc: doc1 },
    { id: 11, title: "Doc Card 1", imgSrc: doc2 },
    { id: 11, title: "Doc Card 1", imgSrc: doc3 },
  ],
};

export default function Card() {
  const [openModal, setOpenModal] = useState(null);
  const [hoveredCard, setHoveredCard] = useState(null);

  const handleButtonClick = (modalId) => {
    setOpenModal(modalId);
  };

  const handleMouseEnter = (num) => {
    setHoveredCard(num);
  };

  const handleMouseLeave = () => {
    setHoveredCard(null);
  };

  // for animation for quick services h1 
  const [animationStage, setAnimationStage] = useState("first-animation");

  // This hook will switch the animation class after each animation ends
  useEffect(() => {
    const animationTimer = setInterval(() => {
      setAnimationStage((prevStage) =>
        prevStage === "first-animation" ? "second-animation" : "first-animation"
      );
    }, 8000); // Total cycle duration for both animations (7 seconds each, with a 1-second gap)

    return () => clearInterval(animationTimer);
  }, []);

  return (
    <>
      <div>
        <h1
          data-aos="fade-up"
          data-aos-anchor-placement="top-bottom"
          className="font-bold sm:text-6xl text-4xl flex justify-center items-center text-center first-animation second-animation"
          style={{ color: "#3A636C" }}
        >
          <span className="text-textColor me-4">Quick</span> Services
        </h1>

        <div className="mx-auto max-w-2xl px-4 sm:px-6 sm:py-32 lg:max-w-7xl lg:px-8">
          <div className="grid lg:grid-cols-3 gap-x-8 gap-y-16">
            {[1, 2, 3, 4, 5, 6].map((num) => {
              const imageUrls = [wd, gd, fin, jas, cc, doc];

              return (
                <div
                  key={num}
                  data-aos={num % 2 === 0 ? "fade-up" : "fade-down-left"}
                  className="relative group"
                  onMouseEnter={() => handleMouseEnter(num)}
                  onMouseLeave={handleMouseLeave}
                >
                  <img
                    data-aos="zoom-in"
                    alt="Product"
                    src={imageUrls[num - 1]}
                    className="bg-gray-100 h-68 w-full transition-transform duration-300 transform group-hover:scale-105"
                  />

                  {/* Button positioned in the left-down corner */}
                  <button
                    className="absolute bottom-0 left-0 bg-customBlue text-white font-bold shadow-lg hover:shadow-xl hover:bg-white hover:text-customBlue transform hover:scale-105 transition duration-300 ease-in-out"
                    style={{
                      width: "4cm",
                      padding: "3mm 4mm",
                      margin: "10px", // Add margin for spacing
                      zIndex: 10, // Ensure button stays on top
                    }}
                    onClick={() => handleButtonClick(num)}
                  >
                    I want Them
                  </button>

                  {/* Hover effect card with additional cards */}
                  {hoveredCard === num && (
                    <div className=" absolute !p-0 inset-0 flex justify-center items-center bg-customBlueheader bg-opacity-90 border transition-all duration-300">
                      <div className="grid grid-cols-3 gap-2">
                        {" "}
                        {/* Grid layout with 3 columns */}
                        {additionalCardsData[num].map((card) => (
                          <div
                            key={card.id}
                            className="m-1 rounded shadow-lg flex items-center"
                            style={{ padding: 0 }} // Remove padding to prevent gaps around the image
                          >
                            <img
                              src={card.imgSrc}
                              alt={card.title}
                              className="w-[120px] h-[100px] object-cover rounded" // Makes the image cover the entire div
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {openModal && (
        <OrderCard modalId={openModal} onClose={() => setOpenModal(null)} />
      )}
    </>
  );
}
